import { render, staticRenderFns } from "./Detalle.vue?vue&type=template&id=2e99cc12&scoped=true&"
import script from "./Detalle.vue?vue&type=script&lang=js&"
export * from "./Detalle.vue?vue&type=script&lang=js&"
import style0 from "./Detalle.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Detalle.vue?vue&type=style&index=1&id=2e99cc12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e99cc12",
  null
  
)

export default component.exports